export default class {
  constructor() {
    this.id = 0;
    this.label = '';
    this.percentDayOne = 0;
    this.percentDayTwo = 0;
    this.percentDayThree = 0;
    this.percentDayFour = 0;
    this.percentDayFive = 0;
    this.percentDaySix = 0;
    this.percentDaySeven = 0;
    this.percentDayEight = 0;
    this.percentDayNine = 0;
    this.percentDayTen = 0;
    this.percentDayEleven = 0;
    this.percentDayTwelve = 0;
    this.percentDayThirteen = 0;
    this.percentDayFourteen = 0;
    this.validFrom = '';
    this.validTo = '';
    this.active = false;
  }

  hydrate(data) {
    if (data?.id) this.id = data.id;
    if (data?.label) this.label = data.label;
    if (data?.percentDayOne) this.percentDayOne = Number(data.percentDayOne);
    if (data?.percentDayTwo) this.percentDayTwo = Number(data.percentDayTwo);
    if (data?.percentDayThree) this.percentDayThree = Number(data.percentDayThree);
    if (data?.percentDayFour) this.percentDayFour = Number(data.percentDayFour);
    if (data?.percentDayFive) this.percentDayFive = Number(data.percentDayFive);
    if (data?.percentDaySix) this.percentDaySix = Number(data.percentDaySix);
    if (data?.percentDaySeven) this.percentDaySeven = Number(data.percentDaySeven);
    if (data?.percentDayEight) this.percentDayEight = Number(data.percentDayEight);
    if (data?.percentDayNine) this.percentDayNine = Number(data.percentDayNine);
    if (data?.percentDayTen) this.percentDayTen = Number(data.percentDayTen);
    if (data?.percentDayEleven) this.percentDayEleven = Number(data.percentDayEleven);
    if (data?.percentDayTwelve) this.percentDayTwelve = Number(data.percentDayTwelve);
    if (data?.percentDayThirteen) this.percentDayThirteen = Number(data.percentDayThirteen);
    if (data?.percentDayFourteen) this.percentDayFourteen = Number(data.percentDayFourteen);
    if (data?.validFrom) this.validFrom = data.validFrom;
    if (data?.validTo) this.validTo = data.validTo;

    // Check discount is valid
    if(this.validTo && this.validFrom) {
      const validFrom = new Date(this.validFrom);
      const validTo = new Date(this.validTo);
      const today = new Date();
      if (validFrom.getTime() < today.getTime() && validTo.getTime() > today.getTime()) {
        this.active = true;
      }
    }
  }
}
